import { useEffect, useState } from "react"

import styles from '../../styles/sort-items.module.scss'

import { Icon } from '../components/core/Icon'

export default function SortItems({items, callback}) {

  const [reorderItems, setReorderItems] = useState([]);

  useEffect(() => {
    setReorderItems(items);
  }, [items]);

  const onSortItem = (position, newPosition) => {
    
    if(newPosition === 'up') {
      const updateList = reorderItems.map((item, i) => {
        if(i === position){
          return {...item, position: i - 1}
        }
        if(i === position - 1){
          return {...item, position: i + 1}
        }
        return {...item, position: i}
      })
      updateList.sort((a, b) => a.position - b.position);
      callback(updateList)
      setReorderItems(updateList)
    }
    if(newPosition === 'down') {
      const updateList = reorderItems.map((item, i) => {
        if(i === position){
          return {...item, position: i + 1}
        }
        if(i === position + 1){
          return {...item, position: i - 1}
        }
        return {...item, position: i}
      })
      updateList.sort((a, b) => a.position - b.position);
      callback(updateList)
      setReorderItems(updateList)
    }
  }

  return (
    <>
      {reorderItems.map((item, i,{length}) => (
        <div className={styles.item} key={i}>
          <span className="w-100">{item.name}</span>
          <div className={styles.chevrons}>
            {i !== 0 ? <Icon name="chevron-up" size="lg" onClick={() => onSortItem(i, 'up')} /> : ''}
            {i !== length -1 ? <Icon name="chevron-down" size="lg" onClick={() => onSortItem(i, 'down')} /> : ''}
          </div>
        </div>
      ))}
    </>
  )
}